// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################


export const NIZKE = 'NIZKE';

export const VYSOKE = 'VYSOKE';

/**
 * Seznam všech hodnot.
 */
export const values = [
    NIZKE,
    VYSOKE
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [NIZKE]: {caption: ''},
    [VYSOKE]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}